"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wall = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const toolbox_1 = require("@streem/toolbox");
const domain_id_1 = require("@streem/domain-id");
const guards_1 = require("./guards");
const logger_1 = require("../../util/logger");
class Wall {
    get tokenExpired() {
        return this._tokenExpired;
    }
    constructor(config) {
        var _a;
        this.config = config;
        this.subscriptions = new toolbox_1.SubscriptionManager();
        this.remoteEvents = new rxjs_1.Subject();
        this.localEvents = new rxjs_1.Subject();
        this.cache = new Map();
        this.wallSyncClient = config.wallSyncClient;
        this.connected = this.wallSyncClient.connected.pipe((0, operators_1.distinctUntilChanged)());
        (_a = this.wallSyncClient.tokenExpired) === null || _a === void 0 ? void 0 : _a.subscribe(expired => {
            logger_1.logger.info(`receiving update to tokenExpired=${expired}`);
            this._tokenExpired = expired;
        });
        this.reconnectFailed = this.wallSyncClient.reconnectFailed;
        this.events = (0, rxjs_1.merge)(this.wallSyncClient.events, this.localEvents);
        this.itemsById = this.events.pipe((0, operators_1.groupBy)(wie => wie.itemId, undefined, undefined, () => new rxjs_1.ReplaySubject(1)), (0, operators_1.publishReplay)());
        this.itemsByType = this.events.pipe((0, operators_1.groupBy)(wie => wie.itemType, undefined, undefined, () => new rxjs_1.ReplaySubject()), (0, operators_1.publishReplay)());
    }
    connect() {
        this.subscriptions.addSubscriptions([
            this.itemsById.connect(),
            this.itemsByType.connect(),
            this.events.subscribe(event => {
                if (event.type === 'DELETED') {
                    this.cache.delete(event.itemId);
                }
                else if (!this.cache.has(event.itemId)) {
                    const ownerId = (0, guards_1.isWallItem)(event.item)
                        ? new domain_id_1.UserId(event.item.ownerUserId)
                        : this.config.localUserId;
                    (0, toolbox_1.invariant)(ownerId, 'Expected to find an ownerId on wall item');
                    this.cache.set(event.itemId, [ownerId, event.itemType]);
                }
            }),
            this.remoteEvents
                .pipe((0, operators_1.groupBy)(event => event.itemId), (0, operators_1.mergeMap)(group => group.pipe((0, operators_1.throttleTime)(500, undefined, { leading: true, trailing: true }))))
                .subscribe({
                next: (event) => __awaiter(this, void 0, void 0, function* () {
                    if (event.type === 'ADDED') {
                        this.wallSyncClient.add(event.item);
                    }
                    else if (event.type === 'UPDATED') {
                        this.wallSyncClient.update(event.item.id, event.item);
                    }
                    else if (event.type === 'DELETED') {
                        this.wallSyncClient.delete(event.itemId);
                    }
                    else {
                        logger_1.logger.error(`Unexpected eventType=${event.type} for wallItemId=${event.itemId}`);
                    }
                }),
            }),
        ]);
        return this.wallSyncClient.connect();
    }
    disconnect() {
        this.subscriptions.unsubscribeAll();
        this.cache.clear();
        this.localEvents.complete();
        this.remoteEvents.complete();
        return this.wallSyncClient.disconnect();
    }
    add(item) {
        if (this.cache.has(item.id)) {
            throw new Error(`WallItem ${item.id} already exists. Please call .update or .addOrUpdate.`);
        }
        this.sendEvent({
            type: 'ADDED',
            itemId: item.id,
            itemType: item.type,
            item,
        });
    }
    update(item) {
        if (!this.cache.has(item.id)) {
            throw new Error(`WallItem wallItemType=${item.type} wallItemId=${item.id} update failed, the item does not exist, add it first`);
        }
        this.assertOwnership(item.id);
        this.sendEvent({
            type: 'UPDATED',
            itemId: item.id,
            itemType: item.type,
            item,
        });
    }
    delete(itemId) {
        const cacheEntry = this.cache.get(itemId);
        if (!cacheEntry) {
            logger_1.logger.warn(`Failed to delete WallItem wallItemId=${itemId}, does not exist.`);
            return false;
        }
        this.assertOwnership(itemId);
        this.sendEvent({
            type: 'DELETED',
            itemId,
            itemType: cacheEntry[1],
        });
        return true;
    }
    addOrUpdate(item) {
        if (this.cache.has(item.id)) {
            this.update(item);
        }
        else {
            this.add(item);
        }
    }
    sendEvent(event) {
        // don't spam logs on heartbeat.
        const level = event.itemType === 'heartbeat' ? 'debug' : 'info';
        logger_1.logger[level](`Sending WallItemEvent eventType=${event.type} wallItemType=${event.itemType} wallItemId=${event.itemId}`);
        this.localEvents.next(event);
        this.remoteEvents.next(event);
    }
    assertOwnership(id) {
        if (!this.isOwner(id)) {
            throw new Error('Cannot update an item you are not the owner of');
        }
    }
    isOwner(id) {
        // Users not logged in are the owners of nothing.
        if (!this.config.localUserId)
            return false;
        // New entires are assumed to be owned by the user.
        const cacheEntry = this.cache.get(id);
        if (!cacheEntry)
            return true;
        // Historical entires must be checked
        const entryOwner = cacheEntry[0];
        return this.config.localUserId.compare(entryOwner);
    }
}
exports.Wall = Wall;
//# sourceMappingURL=wall.js.map